import { api } from './api';

class DealerService {
  // ─── Dealers ──────────────────────────────────────────────────────────────
  async getDealers(params = {}) {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return api.get(`/api/admin/dealers${qs ? `?${qs}` : ''}`);
  }

  async createDealer(data) {
    return api.post('/api/admin/dealers', data);
  }

  async updateDealer(id, data) {
    return api.put(`/api/admin/dealers/${id}`, data);
  }

  async deleteDealer(id) {
    return api.delete(`/api/admin/dealers/${id}`);
  }

  async getDealerLocations(dealerId) {
    return api.get(`/api/admin/dealers/${dealerId}/locations`);
  }

  // ─── Client Service Rates ─────────────────────────────────────────────────
  async getClientServiceRates(params = {}) {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return api.get(`/api/admin/client-service-rates${qs ? `?${qs}` : ''}`);
  }

  async createClientServiceRate(data) {
    return api.post('/api/admin/client-service-rates', data);
  }

  async updateClientServiceRate(id, data) {
    return api.put(`/api/admin/client-service-rates/${id}`, data);
  }

  async deleteClientServiceRate(id) {
    return api.delete(`/api/admin/client-service-rates/${id}`);
  }

  // ─── Scheme Service Types ─────────────────────────────────────────────────
  async getSchemeServiceTypes(params = {}) {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return api.get(`/api/admin/scheme-service-types${qs ? `?${qs}` : ''}`);
  }

  async createSchemeServiceType(data) {
    return api.post('/api/admin/scheme-service-types', data);
  }

  async updateSchemeServiceType(id, data) {
    return api.put(`/api/admin/scheme-service-types/${id}`, data);
  }

  async deleteSchemeServiceType(id) {
    return api.delete(`/api/admin/scheme-service-types/${id}`);
  }

  // ─── Scheme Service Subtypes ──────────────────────────────────────────────
  async getSchemeServiceSubtypes(params = {}) {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return api.get(`/api/admin/scheme-service-subtypes${qs ? `?${qs}` : ''}`);
  }

  async createSchemeServiceSubtype(data) {
    return api.post('/api/admin/scheme-service-subtypes', data);
  }

  async updateSchemeServiceSubtype(id, data) {
    return api.put(`/api/admin/scheme-service-subtypes/${id}`, data);
  }

  async deleteSchemeServiceSubtype(id) {
    return api.delete(`/api/admin/scheme-service-subtypes/${id}`);
  }

  // ─── Service Status Catalog (Phase 1) ─────────────────────────────────────
  async getServiceStatuses(params = {}) {
    const qs = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return api.get(`/api/admin/service-statuses${qs ? `?${qs}` : ''}`);
  }

  async createServiceStatus(data) {
    return api.post('/api/admin/service-statuses', data);
  }

  async updateServiceStatus(id, data) {
    return api.put(`/api/admin/service-statuses/${id}`, data);
  }

  async deleteServiceStatus(id) {
    return api.delete(`/api/admin/service-statuses/${id}`);
  }

  // ─── SMS templates (Maintenance) ───────────────────────────────────────
  async getSmsTemplates() {
    return api.get('/api/admin/sms-templates');
  }

  async updateSmsTemplate(key, data) {
    return api.put(`/api/admin/sms-templates/${key}`, data);
  }

  async createSmsTemplate(data) {
    return api.post('/api/admin/sms-templates', data);
  }

  async deleteSmsTemplate(key) {
    return api.delete(`/api/admin/sms-templates/${key}`);
  }

  // ─── Client schemes (for dropdowns) ──────────────────────────────────────
  async getClientSchemes() {
    return api.get('/api/admin/client-schemes');
  }
}

export const dealerService = new DealerService();
